<template>
<div 
>
    <v-dialog
      v-model="menu"
      lazy
      hide-overlay
      width="650px"
      
    >
      <template v-slot:activator="{ on }">
        <v-btn
		  		:color="strongColor"
          dark
					large
          scrollable="false"
          v-on="on"
        >Display Options</v-btn>
      </template>
      <v-card>
		<!---- START TOOLBAR ---> 
		<v-toolbar
      :color="strongColor"
      flat
      dark>	
      <v-btn
        :color="strongColor"
        dark
        icon
        @click="menu = false">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title
      >Display Options
      </v-toolbar-title>
 	  </v-toolbar>
    <v-container
      ml-3
      justify-start
      align-start>
    <v-layout
    row> 
      <v-flex 
      xs5
      ml-3>
        <v-card flat>
          <v-card-title
            class="pl-0 ml-0 my-1">
            Basic Desires (On/Off)
            </v-card-title>     
          <div v-if="nodeList && nodeList.length > 0 && newNodeList && newNodeList.length > 0">
          <div
            v-for="node in newNodeList"
            id="checkedAttrs"
            :key="node.attr"
            class="checkboxes">
            <v-layout 
              row
              pa3>  
              <v-flex class="text-xs-left pl-2 my-1">
                <p-check
                  v-model="checkedAttrs"
                  :name="node.attr"
                  :value="node.attr"
                  class="p-switch p-fill"
                  checked="true"
                >
                  {{ node.attr }}
                </p-check>
              </v-flex>
            </v-layout> 
        </div>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs6>
    <v-card flat>
      <v-card-title
        class="pl-0 ml-0 my-1 text--font-weight-bold">
       <div class="options"> Graph Display Options </div>
      </v-card-title>    
      <v-layout column>
      <v-layout row> 
        <v-flex 
        class="text-xs-left" 
        xs12>
          <p-check
            v-model="standardGraph"
            :value="!standardGraph"
            name="standardGraph"
            class="p-switch p-fill my-2 align-start"
            checked="true">
            <div 
              v-if="standardGraph"
              >
                Standard Graph
              </div>
              <div 
                v-if="!standardGraph"
                >
                Unidirectional Graph
              </div>
            </p-check>
          </v-flex>             
      </v-layout>
         
          <!---- row -----> 
          <v-layout row> 
            <v-flex 
            class="text-xs-left" 
            xs12>
              <p-check
                v-model="scoresNotDisplayed"
                :value="!scoresNotDisplayed"
                name="scoresNotDisplayed"
                color="white"
                class="p-switch p-fill mr-4 my-2"
                checked="true"
              >
           <div 
            v-if="scoresNotDisplayed"
            >Graph without Scores</div>
            <div 
            v-if="!scoresNotDisplayed"
            >Graph with Scores</div>
            </p-check>
          </v-flex>
        </v-layout>
        <!---- row -----> 

         <!---- row -----> 
         <v-layout row> 
          <v-flex 
           class="text-xs-left" 
           xs12>
            <p-check
            v-model="alphabetical"
            :value="!alphabetical"
            name="alphabetical"
            class="p-switch p-fill mr-4 my-2"
            checked="true"
            >
            <div 
              v-if="alphabetical"
              >Basic Desires Listed Alphabetically</div>
            <div 
              v-if="!alphabetical"
            >Basic Desires Rank Ordered by Absolute Value</div>
            </p-check>
              </v-flex>   
      </v-layout> 
        <!---- row -----> 
  </v-layout>
</v-card>
</v-flex>
   </v-layout>
    </v-container>
    </v-card>
    </v-dialog>
    </div>
</template>

<script>
import {mapState} from 'vuex'
//import '@/components/globals/pdfGenerator.js'
import PrettyCheckbox from 'pretty-checkbox-vue'
import EventBus from '@/main.js'
import {SPORTS, SCHOOL, SD, BUSINESS, ATTR_LIST_B, ATTR_LIST_R, ATTR_LIST_RSMP, STRONG_COLOR } from '@/components/globals/consts.js'
export default {
  props: ['nodeList'],
  /*props: {
   nodeList: {
     type: Array,
     default: [],
     required: true
   }
  },*/
  data () {
    return {
      checkedAttrs: null, // ATTR_LIST_B.sort(),
      newNodeList: [],
      standardGraph: true,
      scoresNotDisplayed: true,
      alphabetical: true,
      menu: false,
      strongColor: STRONG_COLOR,
      attrListB: ATTR_LIST_B,
      attrListR: ATTR_LIST_R,
      attrListRSMP: ATTR_LIST_B /// THIS assumes 16 in 
    } 
  },
	computed: {
		...mapState([
			'isUserLoggedIn',
			'user',
      'route',
      'testType',
      'testAttributes'
		])
  },

  watch: {
		'checkedAttrs': {
			immediate: true,
			async handler () {
         if (this.checkedAttrs !== null) {
            await this.emitMethod('barCheckedAttrs', this.checkedAttrs)
         }
      }
    }, 
		'alphabetical': {
			immediate: true,
			async handler () {
            await this.emitMethod('toggleBarNeedsOrder', this.alphabetical)
      }
    },
		'nodeList': {
			immediate: true,
			async handler () {
        if (this.nodeList != null) {
        let newNodeList = this.nodeList.slice()
        this.newNodeList = await newNodeList.sort(this.orderByAttrVal)
      }
      }
    },
		'standardGraph': {
			immediate: true,
			async handler () {
            await this.emitMethod('toggleBarGraphType', this.standardGraph)
      }
    },
		'scoresNotDisplayed': {
			immediate: true,
			async handler () {
            await this.emitMethod('toggleBarScores', this.scoresNotDisplayed)
      }
    }
  },
  async mounted () {
    
    if (this.testType === BUSINESS || this.testType === SPORTS || this.testType === SCHOOL) { 
      let attrB = this.attrListB.slice()
      this.checkedAttrs = await attrB.sort()
    }
    else if (this.testType === SD) {
      let attrR = this.attrListR.slice()
      this.checkedAttrs = await attrR.sort()
    }
    try {
      if (this.nodeList != null) {
        let newNodeList = this.nodeList.slice()
        this.newNodeList = await newNodeList.sort(this.orderByAttrVal)
      }
    } catch (e)  {
      console.log(e)
    }  
  },
  /*async mounted () {
    //if (this.nodeList != null) {
      //this.nodeList.sort(this.orderByAttrVal)
      let newNodeList = this.nodeList.slice()
      this.newNodeList = await newNodeList.sort(this.orderByAttrVal)
      //this.checkedAttrs.sort()
    //}
  },*/

  beforeDestroy() {
    try {
      //this.nodeList = []
      //this.nodeList.destroy()
      this.checkedAttrs = null


    } catch (err) {
      console.log(err);
    }
  },


   methods: {
    async emitMethod (name, value) {
      //console.log(this.$data.checkedAttrs)
      if (value !== undefined && value !== null) {
          await EventBus.$emit(name, value)
      }
    },
    orderByAttrVal (a, b) {
      if (a.attr > b.attr) {
        return 1
      } else if (a.attr < b.attr) {
        return -1
      }
      return 0
   }
  }
}
</script>
<style scoped>
.checkboxes {
  text-align: left;
  color: black;
  font-family: 'Arial';
  font-size: 14px;
}
.attrs {
  text-align: left;
  color: black;
  font-family: 'Arial';
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/ViewClient/ViewClientOptions.vue